import BaseSystemApi from 'api/BaseSystemApi';
import { env } from 'env';

export default class WebhooksSystemApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = env.REACT_APP_WEBHOOKS_API_URL;
}
